import React from 'react'
import { useConfig } from 'msp-integrations'

type TextAreaProps = {
  cols?: number
  disabled?: boolean
  error?: boolean
  isRequired?: boolean
  label?: React.ReactNode | string
  maxLength?: number
  name?: string
  placeholder?: string
  readonly?: boolean
  rows?: number
  errorMessage?: string
  resizeable?: boolean
}

const TextArea = ({
  cols = 30,
  disabled = false,
  error = false,
  isRequired = false,
  label = '',
  maxLength = 100,
  name = '',
  placeholder = '',
  readonly = false,
  rows = 5,
  errorMessage,
  resizeable = false,
  ...rest
}: TextAreaProps) => {
  const {
    theme: {
      font: { regular: font }
    }
  } = useConfig()
  const textAreaStyles = {
    initial:
      'border-machine2-75 group-hover:border-machine4-100 focus:border-machine4-100 focus:outline-none focus:ring-2 focus:ring-coffee1-100 transition',
    error:
      'border-errorRed group-hover:border-errorRed focus:border-errorRed focus:outline-none'
  }

  return (
    <div className='font-GoodPro text-machine2-75 group relative mt-3 w-fit'>
      <label
        className={`group-hover:text-machine4-100 absolute whitespace-nowrap px-[6px]
            tracking-normal transition-colors ${
              disabled
                ? 'text-mediumGray m-2 -translate-y-0 bg-transparent'
                : 'ml-[18px] -translate-y-[52%] bg-white'
            } ${
          error && 'group-hover:text-errorRed after:text-errorRed text-errorRed'
        } ${isRequired && 'after:content-["*"]'}`}
      >
        {label}
      </label>

      <textarea
        className={`font-GoodPro text-14 text-machine4-100 w-full rounded border bg-white px-6 py-4 font-medium ${
          !resizeable ? 'resize-none' : ''
        } ${
          error ? textAreaStyles.error : textAreaStyles.initial
        } disabled:bg-machine2-25 disabled:pointer-events-none disabled:outline-none`}
        cols={cols}
        disabled={disabled}
        maxLength={maxLength}
        name={name}
        placeholder={placeholder}
        readOnly={readonly}
        rows={rows}
        {...rest}
      />
      {error && errorMessage && (
        <span className={`text-errorRed ${font}`}>{errorMessage}</span>
      )}
    </div>
  )
}

export default TextArea
